import formatErrors from '../../../functions/formatErrors';
import { UserState } from '../objects/userState';
import {
    ADD_PREFERENCES,
    MOVE_DOWN_COLUMN,
    MOVE_UP_COLUMN,
    RESET_FILTERS,
    RESET_PROFIL_PICTURE,
    RESET_USER,
    SET_ACTIVATE_USER,
    SET_DELETE_USER,
    SET_DELETE_USERS,
    SET_ERRORS,
    SET_EXPORT_TYPE,
    SET_LIMIT,
    SET_LIST,
    SET_LIST_SCOPE,
    SET_MOVE_ORGANISATION_ORGANISATION,
    SET_MOVE_ORGANISATION_USER,
    SET_ORDER_BY,
    SET_PAGE,
    SET_PASSWORD_ID,
    SET_PICTURE_ERRORS,
    SET_POST_FINISHED,
    SET_POST_RESPONSE,
    SET_PREFERENCES as SET_USER_PREFERENCES,
    SET_RUNNING,
    SET_SEARCH,
    SET_SUSPEND_USER,
    SET_SUSPEND_USERS,
    SET_UPLOAD_PICTURE_VIDEO_INPUT,
    SET_USER,
    SET_USER_STATS,
    TOGGLE_AGENCY_DIRECTOR,
    TOGGLE_NETWORK_DIRECTOR,
    TOGGLE_BO_AGENT,
    TOGGLE_CC_CREATOR,
    TOGGLE_COLUMN,
    TOGGLE_CREATE,
    TOGGLE_CUSTOM_PERMISSIONS,
    TOGGLE_EMAIL_PREVIEW,
    TOGGLE_EXPORT,
    TOGGLE_EXPORT_FULL,
    TOGGLE_FILTERS,
    SET_FILTER_OPEN,
    TOGGLE_FIRST_BLOCK,
    TOGGLE_IS_CUSTOMER,
    TOGGLE_LIST_ALL,
    TOGGLE_LICENCE_HISTORY,
    TOGGLE_MOVE_ORGANISATION_CHANGE_TRIP,
    TOGGLE_PROFILE_DEPLOYED,
    TOGGLE_REFRESH,
    TOGGLE_ROLE_DEPLOYED,
    TOGGLE_SELLER_AGENT,
    TOGGLE_SUPPORT_ACCESS,
    TOGGLE_SUSPEND_TRANSFER,
    TOGGLE_UPDATE_PASSWORD,
    TOGGLE_UPLOAD_PICTURE,
    TOGGLE_USER_TRANSFER,
    TOGGLE_USER_TRANSFER_ERROR,
    UPDATE_BIOGRAPHY,
    UPDATE_CELLPHONE_NUMBER,
    UPDATE_CITY,
    UPDATE_CLIENT,
    UPDATE_CLIENTS,
    UPDATE_COMPANY,
    UPDATE_COUNTRY,
    UPDATE_EMAIL,
    UPDATE_FILTER_CMS,
    UPDATE_FILTER_COMPANY,
    UPDATE_FILTER_CREATOR,
    UPDATE_FILTER_DATE_JOINED_GTE,
    UPDATE_FILTER_DATE_JOINED_LTE,
    UPDATE_FILTER_EMAIL,
    UPDATE_FILTER_EMAIL_CHECKED,
    UPDATE_FILTER_FIRST_NAME,
    UPDATE_FILTER_LAST_AUTHOR,
    UPDATE_FILTER_LAST_NAME,
    UPDATE_FILTER_LICENCE_TYPE,
    UPDATE_FILTER_MODIFIED_DATE_GTE,
    UPDATE_FILTER_MODIFIED_DATE_LTE,
    UPDATE_FILTER_PERIOD,
    UPDATE_FILTER_PERIOD_TYPE,
    UPDATE_FILTER_SHOW_DEACTIVATED,
    UPDATE_FILTER_USER_TYPE,
    UPDATE_FIRST_NAME,
    UPDATE_GENERATE_PASSWORD,
    UPDATE_IGA_PASSWORD,
    UPDATE_IGA_USERNAME,
    UPDATE_LANG,
    UPDATE_BRANCH_CODE,
    UPDATE_ADDITIONAL_BRANCH_CODES,
    UPDATE_CONFIRM_PASSWORD,
    UPDATE_LAST_NAME,
    UPDATE_LIST_ORGANISATIONS,
    UPDATE_MOVE_SECONDARY_ORGANISATIONS,
    UPDATE_PASSWORD,
    UPDATE_PHONE_NUMBER,
    UPDATE_PICTURE,
    UPDATE_PICTURE_PROGRESS,
    UPDATE_PICTURE_STEP,
    UPDATE_ROLE,
    UPDATE_STATE,
    UPDATE_STREET,
    UPDATE_TRIGRAM,
    UPDATE_USER_SELECTED,
    UPDATE_USER_TRANSFER,
    UPDATE_USER_TRIP_TRANSFER,
    UPDATE_USERNAME,
    UPDATE_TITLE,
    UPDATE_ZIP_CODE,
    UserActionTypes,
    TOGGLE_IS_COMMERCIAL,
    SET_COLUMNS,
    SET_USER_SUGGESTIONS,
    SET_USER_SUGGESTION_SELECTED,
    UNSELECT_USER_CRM,
    UPDATE_ALLOWED_EVENTS,
    UPDATE_ALLOWED_TEAMS,
    UPDATE_CMS,
    SET_ALLOWED_LICENCE_TYPES,
    SET_LICENCE_TYPE,
    SET_LICENCE_FINANCE_ADDON,
    SET_LICENCE_HISTORY_COLUMNS,
    TOGGLE_LICENCE_HISTORY_COLUMN,
    ADD_LICENCE_HISTORY_PREFERENCE,
    SET_LICENCE_HISTORY_PREFERENCE,
    UPDATE_LICENCE_HISTORY_CRITERIA,
    UPDATE_LICENCE_HISTORY_LOADING,
    TOGGLE_LICENCE_HISTORY_REFRESH,
    RESIZE_COLUMN
} from './actionTypes';
import { LICENCE_HISTORY_DEFAULT_COLUMNS, LICENCE_HISTORY_DEFAULT_CRITERIA, LICENCE_HISTORY_MODULE } from '../constant/licenceHistoryConstant';
import { canHaveFinanceAddon } from '../utils/getLicenceBooleans';
import { setLicenceHistoryPreference as mapLicenceHistoryPreference } from '../utils/setLicenceHistoryPreference';
import { ProfileActionTypes, SET_PREFERENCES } from '../../profile/redux/actionTypes';
import { Column } from '../objects/column';
import { Preferences } from '../../profile/objects/preferences';
import { OrganisationMinimal } from '../../organisation/objects/organisationMinimal';
import { applyColumnResize } from '../../utils/list/utils/columnResize';
import { setUserPreference, DEFAULT_USER_COLUMNS, MCI_USER_COLUMNS } from '../utils/setUserPreference';
import { UserListContext } from '../objects/userListContext';

const subDomain = window.location.host.split('.')[0];
const domain = window.location.host.split('.')[1];

export const defaultColumn: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'first_name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'username',
    field_name: 'USERNAME',
    checked: false,
    order_by: 'username',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'email',
    field_name: 'EMAIL',
    checked: true,
    order_by: 'email',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'organisation',
    field_name: 'ORGANISATION',
    checked: true,
    order_by: 'client__name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'date-joined',
    field_name: 'DATE_JOINED',
    checked: false,
    order_by: 'date_joined',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'email-checked',
    field_name: 'EMAIL_CHECKED',
    checked: true,
    order_by: 'email_checked',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'cms-attached',
    field_name: 'CMS_ATTACHED',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}];

export const mciColumns: Column[] = [...defaultColumn, {
    label: 'company',
    field_name: 'COMPANY',
    checked: true,
    order_by: 'company',
    fixed_width: false,
    last_updated: false,
    width: null
}];

const initialState: UserState = {
    activate_user: null,
    avatar: null,
    biography: '',
    birth_date: null,
    cc_creator: false,
    cellphone_number: null,
    cellphone_number_error: '',
    city: '',
    city_error: '',
    client: null,
    clients: [],
    client_error: '',
    client_full: null,
    client_list: null,
    columns: (domain === 'tripmci' ? MCI_USER_COLUMNS : DEFAULT_USER_COLUMNS).map(column => ({...column})),
    company:null,
    company_error:'',
    count: 0,
    country: null,
    country_error: '',
    create: false,
    create_max: false,
    creator: null,
    custom_permissions: [],
    date_joined: null,
    delete_user: null,
    email: '',
    email_checked: false,
    email_error: '',
    email_preview: false,
    export_full: false,
    export_list: false,
    export_type: 'CSV',
    filter_cms: [],
    filter_company: '',
    filter_creator: '',
    filter_date_joined_gte: null,
    filter_date_joined_lte: null,
    filter_email: '',
    filter_email_checked: '',
    filter_first_name: '',
    filter_last_author: '',
    filter_last_name: '',
    filter_licence_type: 'ALL',
    filter_modified_date_gte: null,
    filter_modified_date_lte: null,
    filter_open: false,
    filter_period: 'CREATION',
    filter_period_type: 0,
    filter_user_type: 'ALL',
    first_block_open: true,
    first_name: '',
    first_name_error: '',
    generate_password: true,
    groups: [],
    crm_groups: [],
    groups_error: '',
    has_custom_permissions: false,
    house_number: null,
    id: null,
    iga_password: '',
    iga_username: '',
    is_active: false,
    is_agency_director: false,
    is_bo_user: false,
    is_customer: false,
    is_network_director: false,
    is_newsletter: false,
    is_seller_user: false,
    is_commercial: false,
    access_to_support: false,
    is_superuser: false,
    is_supervisor: false,
    lang: null,
    lang_error: '',
    branch_code: null,
    additional_branch_codes: null,
    last_author: null,
    last_login: null,
    last_name: '',
    last_name_error: '',
    limit: 50,
    list: null,
    list_all: true,
    list_contexts: { TO: null, B2B: null, B2C: null },
    list_organisations: [],
    list_scope: 'TO',
    list_selected: [],
    modified_date: null,
    move_organisation_change_trip: true,
    move_organisation_organisation: null,
    move_organisation_secondary_organisations: [],
    move_organisation_user: null,
    order: 'asc',
    order_by: 'first_name',
    ordering: null,
    ordering_ascend: false,
    page: 0,
    confirm_password: '',
    password: '',
    password_error: '',
    password_client: null,
    password_id: null,
    password_name: '',
    perms: null,
    phone_number: '',
    phone_number_error: '',
    picture: null,
    picture_errors: null,
    picture_progress: 0,
    post_finished: false,
    post_response: null,
    preferences: [],
    licence_history: false,
    profile_deployed: false,
    refresh: false,
    running: false,
    role_deployed: false,
    search: '',
    show_deactivated: 'HIDE',
    state: '',
    state_error: '',
    street: '',
    street_error: '',
    suspend_transfer: false,
    suspend_user: null,
    timezone: null,
    travelers: null,
    transfer: true,
    trigram: '',
    trigram_error: '',
    trip_confirmed: 0,
    trip_total: 0,
    update_password: true,
    upload_picture: false,
    upload_picture_step: 1,
    upload_picture_video_input: false,
    user: null,
    username: '',
    username_error :'',
    title: 'MR',
    title_error :'',
    user_transfer: null,
    user_transfer_error: false,
    user_trip_transfer: null,
    using_currency: null,
    zip_code: '',
    zip_code_error: '',
    user_suggestions: [],
    user_suggestion_selected: null,
    allowed_event_sites: [],
    user_teams: [],
    is_bi_viewer: false,
    is_bi_creator: false,
    is_bi_only: false,
    creating_user_client: false,
    allowed_licence_types: [],
    licence_type: 'BO',
    licence_finance_addon: false,
    licence_history_configuration: { columns: LICENCE_HISTORY_DEFAULT_COLUMNS, preferences: [] },
    licence_history_criteria: LICENCE_HISTORY_DEFAULT_CRITERIA,
    licence_history_loading: false,
    licence_history_first_preference_loaded: false,
    licence_history_refresh: false,
    cms: null,
    cms_error: ''
};

/**
 * Les listes TO (userList), B2B (userB2bList) et B2C (userB2cList) partagent ce slice et les
 * mêmes composants de liste : on isole ce qui est propre à chaque liste (colonnes, filtres,
 * tri, pagination) dans un contexte échangé au montage via SET_LIST_SCOPE.
 */
const getListContext = (state: UserState): UserListContext => ({
    columns: state.columns,
    count: state.count,
    filter_cms: state.filter_cms,
    filter_company: state.filter_company,
    filter_creator: state.filter_creator,
    filter_date_joined_gte: state.filter_date_joined_gte,
    filter_date_joined_lte: state.filter_date_joined_lte,
    filter_email: state.filter_email,
    filter_email_checked: state.filter_email_checked,
    filter_first_name: state.filter_first_name,
    filter_last_author: state.filter_last_author,
    filter_last_name: state.filter_last_name,
    filter_licence_type: state.filter_licence_type,
    filter_modified_date_gte: state.filter_modified_date_gte,
    filter_modified_date_lte: state.filter_modified_date_lte,
    filter_open: state.filter_open,
    filter_period: state.filter_period,
    filter_period_type: state.filter_period_type,
    filter_user_type: state.filter_user_type,
    first_block_open: state.first_block_open,
    limit: state.limit,
    list: state.list,
    list_all: state.list_all,
    list_organisations: state.list_organisations,
    list_selected: state.list_selected,
    order: state.order,
    order_by: state.order_by,
    page: state.page,
    search: state.search,
    show_deactivated: state.show_deactivated
});

const getDefaultListContext = (default_columns: Column[]): UserListContext => ({
    ...getListContext(initialState),
    columns: default_columns.map(column => ({...column}))
});

export default (state = initialState, action: UserActionTypes | ProfileActionTypes): UserState => {
    switch (action.type) {
        case ADD_PREFERENCES: {
            return { ...state, preferences: [...state.preferences, ...action.payload] };
        }
        case MOVE_DOWN_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = { ...columns[action.payload + 1] };
            columns[action.payload + 1] = columns[action.payload];
            columns[action.payload + 1].last_updated = true;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case MOVE_UP_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = { ...columns[action.payload - 1] };
            columns[action.payload - 1] = columns[action.payload];
            columns[action.payload - 1].last_updated = true;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case RESET_FILTERS: {
            return {
                ...state,
                filter_company: '',
                filter_creator: '',
                filter_date_joined_gte: null,
                filter_date_joined_lte: null,
                filter_email: '',
                filter_email_checked: '',
                filter_first_name: '',
                filter_last_author: '',
                filter_last_name: '',
                filter_licence_type: 'ALL',
                filter_modified_date_gte: null,
                filter_modified_date_lte: null,
                filter_period: 'CREATION',
                filter_period_type: 0,
                filter_user_type: 'ALL',
            };
        }
        case RESET_USER: {
            return {
                ...state,
                create: false,
                creating_user_client: false,
                client: null,
                picture: null,
                first_name: '',
                first_name_error: '',
                last_name: '',
                last_name_error: '',
                phone_number: '',
                phone_number_error: '',
                email: '',
                email_error: '',
                username: '',
                username_error: '',
                title: 'MR',
                title_error: '',
                confirm_password: '',
                password: '',
                company: null,
                company_error: '',
                street:'',
                zip_code:'',
                allowed_event_sites: [],
                user_teams: [],
                city:'',
                country: null,
                trigram: '',
                trigram_error: '',
                biography:'',
                lang: null,
                branch_code: null,
                additional_branch_codes: null,
                groups: [],
                crm_groups: [],
                is_agency_director: false,
                is_network_director: false,
                is_bo_user: false,
                is_seller_user:false,
                is_commercial: false,
                access_to_support: false,
                custom_permissions: [],
                profile_deployed: false,
                user: null,
                has_custom_permissions: false,
                cms: null,
                cms_error: '',
                allowed_licence_types: [],
                licence_type: 'BO',
                licence_finance_addon: false,
            };
        }
        case RESET_PROFIL_PICTURE: {
            return { ...state, picture: null };
        }
        case SET_ACTIVATE_USER: {
            if (action.payload === null && state.activate_user !== null && state.list) {
                const list = state.list ? [...state.list] : state.list;
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === state.activate_user.id) {
                        list[i].is_active = true;
                        break;
                    }
                }
                return { ...state, activate_user: action.payload, list: list };
            } else if (action.payload === false) {
                return { ...state, activate_user: null };
            } else {
                return { ...state, activate_user: action.payload };
            }
        }
        case SET_DELETE_USER: {
            if (action.payload === null && state.delete_user !== null && state.list) {
                const list = state.list ? [...state.list] : state.list;
                let count = state.count;
                if (Array.isArray(state.delete_user)) {
                    state.delete_user.map(user => {
                        for (let i = 0; i < list.length; i++) {
                            if (list[i].id === user.id) {
                                list.splice(i, 1);
                                count--;
                                break;
                            }
                        }
                    });
                } else {
                    for (let i = 0; i < list.length; i++) {
                        if (list[i].id === state.delete_user.id) {
                            list.splice(i, 1);
                            count--;
                            break;
                        }
                    }
                }
                return { ...state, count: count, delete_user: action.payload, list: list };
            } else if (action.payload === false) {
                return { ...state, delete_user: null };
            } else {
                return { ...state, delete_user: action.payload };
            }
        }
        case SET_DELETE_USERS: {
            return { ...state, delete_user: state.list_selected };
        }
        case SET_ERRORS: {
            const { email, first_name, groups, last_name, password, phone_number, trigram, username, title ,company, cellphone_number, street, zip_code, city, state_error, lang, cms } = action.payload;
            return {
                ...state,
                email_error: email ? (Array.isArray(email) ? formatErrors(email) : email) : state.email_error,
                first_name_error: first_name ? (Array.isArray(first_name) ? formatErrors(first_name) : first_name) : state.first_name_error,
                groups_error: groups ?( Array.isArray(groups) ? formatErrors(groups) : groups) : state.groups_error,
                last_name_error: last_name ? (Array.isArray(last_name) ? formatErrors(last_name) : last_name) : state.last_name_error,
                password_error: password ? (Array.isArray(password) ? formatErrors(password) : password) : state.password_error,
                phone_number_error: phone_number ? (Array.isArray(phone_number) ? formatErrors(phone_number) : phone_number) : state.phone_number_error,
                cellphone_number_error: cellphone_number ? (Array.isArray(cellphone_number) ? formatErrors(cellphone_number) : cellphone_number) : state.cellphone_number_error,
                trigram_error: trigram ? (Array.isArray(trigram) ? formatErrors(trigram) : trigram) : state.trigram_error,
                username_error: username ? (Array.isArray(username) ? formatErrors(username) : username) : state.username_error,
                title_error: title ? (Array.isArray(title) ? formatErrors(title) : title) : state.title_error,
                company_error: company? (Array.isArray(company) ? formatErrors(company) : company) : state.company_error,
                street_error: street? (Array.isArray(street) ? formatErrors(street) : street) : state.street_error,
                zip_code_error: zip_code? (Array.isArray(zip_code) ? formatErrors(zip_code) : zip_code) : state.zip_code_error,
                city_error: city? (Array.isArray(city) ? formatErrors(city) : city) : state.city_error,
                state_error: state_error? (Array.isArray(state_error) ? formatErrors(state_error) : state_error) : state.state_error,
                lang_error: lang ? Array.isArray(lang) ? formatErrors(lang) : lang : '',
                cms_error: cms ? Array.isArray(cms) ? formatErrors(cms) : cms : '',
            };
        }
        case SET_EXPORT_TYPE: {
            return { ...state, export_type: action.payload };
        }
        case SET_LIMIT: {
            return { ...state, list: null, limit: action.payload };
        }
        case SET_LIST: {
            const { count, results } = action.payload;
            return { ...state, count: count, list: results, running: false };
        }
        case SET_LIST_SCOPE: {
            const { scope, default_columns } = action.payload;
            if (scope === state.list_scope) {
                return state;
            }
            const list_contexts = {...state.list_contexts, [state.list_scope]: getListContext(state)};
            const next_context = list_contexts[scope] !== null ? list_contexts[scope] as UserListContext : getDefaultListContext(default_columns);
            return {...state, ...next_context, list_contexts: list_contexts, list_scope: scope};
        }
        case SET_MOVE_ORGANISATION_ORGANISATION: {
            return { ...state, move_organisation_organisation: action.payload };
        }
        case SET_MOVE_ORGANISATION_USER: {
            const move_organisation_secondary_organisations: OrganisationMinimal[] = [];
            if (action.payload !== null && action.payload.client_list !== null) {
                action.payload.client_list.map(client => {
                    if (client.id !== action.payload?.client) {
                        move_organisation_secondary_organisations.push({ ...client });
                    }
                });
            }
            return { ...state, move_organisation_user: action.payload, move_organisation_organisation: null, move_organisation_change_trip: false, move_organisation_secondary_organisations: move_organisation_secondary_organisations };
        }
        case SET_ORDER_BY: {
            return { ...state, list: null, order_by: action.payload, order: state.order_by === action.payload && state.order === 'asc' ? 'desc': 'asc' };
        }
        case SET_PAGE: {
            return { ...state, list: null, page: action.payload };
        }
        case SET_PASSWORD_ID: {
            return { ...state, password_client: action.payload.client, password_id: action.payload.id, password_name: action.payload.name };
        }
        case SET_PICTURE_ERRORS: {
            return { ...state, upload_picture: false, picture_progress: 0, picture_errors: action.payload };
        }
        case SET_POST_FINISHED: {
            if (action.payload) {
                return { ...state, refresh: !state.refresh, post_finished: action.payload };
            } else {
                return {
                    ...state,
                    avatar: null,
                    biography: '',
                    birth_date: null,
                    cc_creator: false,
                    cellphone_number: null,
                    cellphone_number_error: '',
                    city: '',
                    city_error: '',
                    client: null,
                    client_error: '',
                    client_full: null,
                    client_list: null,
                    company: null,
                    company_error:'',
                    country: null,
                    country_error: '',
                    create: false,
                    creating_user_client: false,
                    create_max: false,
                    creator: null,
                    custom_permissions: [],
                    date_joined: null,
                    delete_user: null,
                    email: '',
                    email_checked: false,
                    email_error: '',
                    email_preview: false,
                    first_name: '',
                    first_name_error: '',
                    generate_password: true,
                    groups: [],
                    crm_groups: [],
                    groups_error: '',
                    has_custom_permissions: false,
                    house_number: null,
                    id: null,
                    is_active: false,
                    is_customer: false,
                    is_newsletter: false,
                    is_superuser: false,
                    is_supervisor: false,
                    lang: null,
                    lang_error: '',
                    branch_code: null,
                    additional_branch_codes: null,
                    last_author: null,
                    last_login: null,
                    last_name: '',
                    last_name_error: '',
                    modified_date: null,
                    move_organisation_user: null,
                    ordering: null,
                    ordering_ascend: false,
                    confirm_password: '',
                    password: '',
                    password_error: '',
                    password_client: null,
                    password_id: null,
                    password_name: '',
                    perms: null,
                    phone_number: '',
                    phone_number_error: '',
                    picture: null,
                    picture_errors: null,
                    picture_progress: 0,
                    post_finished: false,
                    post_response: null,
                    profile_deployed: false,
                    role_deployed: false,
                    state: '',
                    state_error: '',
                    street: '',
                    street_error: '',
                    suspend_user: null,
                    timezone: null,
                    travelers: null,
                    trigram: '',
                    trigram_error: '',
                    trip_confirmed: 0,
                    trip_total: 0,
                    update_password: true,
                    user: null,
                    username: '',
                    username_error :'',
                    title: 'MR',
                    title_error :'',
                    using_currency: null,
                    zip_code: '',
                    zip_code_error: '',
                    allowed_event_sites: [],
                    user_teams: [],
                };
            }
        }
        case SET_POST_RESPONSE: {
            return { ...state, post_response: action.payload };
        }
        case SET_PREFERENCES: {
            // Les préférences serveur (module USER) concernent la liste TO, seule à monter
            // UserListPreferences : depuis une autre liste, on les range dans son contexte au lieu
            // d'écraser les colonnes affichées.
            const to_columns = state.list_scope !== 'TO' && state.list_contexts.TO !== null ? state.list_contexts.TO.columns : state.columns;
            const { columns, preferences, order_by, order } = setUserPreference(action.payload, to_columns);
            let base_return: UserState;
            if (state.list_scope !== 'TO') {
                const to_context = state.list_contexts.TO !== null ? state.list_contexts.TO : getListContext(state);
                base_return = {
                    ...state,
                    preferences,
                    list_contexts: { ...state.list_contexts, TO: { ...to_context, columns, order_by, order } }
                };
            } else {
                base_return = { ...state, columns, preferences, order_by, order };
            }
            const licence_history_raw_preferences: Preferences[] = action.payload.filter(preference => preference.module === LICENCE_HISTORY_MODULE);
            if (licence_history_raw_preferences.length > 0) {
                const mapped = mapLicenceHistoryPreference(licence_history_raw_preferences, state.licence_history_configuration.columns);
                return {
                    ...base_return,
                    licence_history_configuration: { columns: mapped.columns, preferences: mapped.preferences },
                    licence_history_first_preference_loaded: true,
                };
            }
            return base_return;
        }
        case RESIZE_COLUMN: {
            return { ...state, columns: applyColumnResize(state.columns, action.payload) };
        }
        case SET_RUNNING: {
            return { ...state, running: action.payload };
        }
        case SET_SEARCH: {
            if (state.search !== action.payload) {
                return { ...state, list: null, page: 0, search: action.payload };
            } else {
                return state;
            }
        }
        case SET_SUSPEND_USER: {
            if (action.payload === null && state.suspend_user !== null && state.list && state.show_deactivated === 'HIDE') {
                const list = [...state.list];
                let count = state.count;
                if (Array.isArray(state.suspend_user)) {
                    state.suspend_user.map(user => {
                        for (let i = 0; i < list.length; i++) {
                            if (list[i].id === user.id) {
                                list.splice(i, 1);
                                count--;
                                break;
                            }
                        }
                    });
                } else {
                    for (let i = 0; i < list.length; i++) {
                        if (list[i].id === state.suspend_user.id) {
                            list.splice(i, 1);
                            count--;
                            break;
                        }
                    }
                }
                return { ...state, count: count, list: list, suspend_user: action.payload };
            } else if (action.payload === false) {
                return { ...state, suspend_user: null };
            } else {
                return { ...state, suspend_user: action.payload };
            }
        }
        case SET_SUSPEND_USERS: {
            return { ...state, suspend_user: state.list_selected };
        }
        case SET_UPLOAD_PICTURE_VIDEO_INPUT: {
            return { ...state, upload_picture_video_input: action.payload };
        }
        case SET_USER: {
            const { avatar, biography, birth_date, cellphone_number, city, client_list, client_full, country, creator,
                date_joined, email, email_checked, first_name, groups, house_number, id, iga_username, is_active, is_agency_director, is_bo_user, is_customer,
                is_network_director, is_newsletter, is_seller_user, is_bi_viewer, is_bi_creator, is_bi_only, is_commercial, access_to_support, is_superuser, is_supervisor, lang, branch_code, additional_branch_codes, last_author, last_login, last_name, modified_date,
                ordering, ordering_ascend, perms, phone_number, street, timezone, travelers, trigram, username, title,
                using_currency, zip_code, user_teams, allowed_event_sites } = action.payload;
            const user_state = action.payload.state;
            return {
                ...state,
                avatar: avatar,
                picture: avatar,
                biography: biography !== null ? biography : '',
                birth_date: birth_date,
                cellphone_number: cellphone_number,
                city: city,
                client_full: client_full,
                client_list: client_list,
                country: country !== null ? country : null,
                creator: creator,
                date_joined: date_joined,
                email: email,
                email_checked: email_checked,
                first_name: first_name,
                groups: groups !== null ? groups.filter((group) => !group.is_crm_role)  : [],
                crm_groups:  groups !== null ? groups.filter((group) => group.is_crm_role)  : [],
                has_custom_permissions: perms ? perms.length > 0 : state.has_custom_permissions,
                house_number: house_number,
                id: id,
                iga_username: iga_username !== null ? iga_username : '',
                is_active: is_active,
                is_agency_director: is_agency_director,
                is_bo_user: is_bo_user,
                is_customer: is_customer,
                is_network_director: is_network_director,
                is_newsletter: is_newsletter,
                is_seller_user: is_seller_user,
                is_commercial: is_commercial,
                access_to_support: access_to_support,
                is_superuser: is_superuser,
                is_supervisor: is_supervisor,
                lang: lang,
                branch_code: branch_code,
                additional_branch_codes: additional_branch_codes ?? null,
                last_author: last_author,
                last_login: last_login,
                last_name: last_name,
                modified_date: modified_date,
                ordering: ordering,
                ordering_ascend: ordering_ascend,
                perms: perms ? perms : state.perms,
                phone_number: phone_number,
                state: user_state,
                street: street,
                timezone: timezone,
                travelers: travelers,
                trigram: trigram,
                user: action.payload,
                username: username,
                title: title || '',
                using_currency: using_currency,
                zip_code: zip_code,
                allowed_event_sites: allowed_event_sites || [],
                user_teams: user_teams || []
            };
        }
        case UNSELECT_USER_CRM: {
            return { ...state, crm_groups: [] };
        }
        case SET_ALLOWED_LICENCE_TYPES: {
            return { ...state, allowed_licence_types: action.payload };
        }
        case SET_LICENCE_TYPE: {
            return { ...state, licence_type: action.payload, licence_finance_addon: canHaveFinanceAddon(action.payload) ? state.licence_finance_addon : false };
        }
        case SET_LICENCE_FINANCE_ADDON: {
            return { ...state, licence_finance_addon: action.payload };
        }
        case SET_USER_PREFERENCES: {
            return { ...state, preferences: action.payload };
        }
        case SET_USER_STATS: {
            const { trip_confirmed, trip_total } = action.payload;
            return { ...state, trip_confirmed: trip_confirmed, trip_total: trip_total };
        }
        case TOGGLE_AGENCY_DIRECTOR: {
            return { ...state, is_agency_director: !state.is_agency_director };
        }
        case TOGGLE_BO_AGENT: {
            return { ...state, is_bo_user: !state.is_bo_user };
        }
        case TOGGLE_CC_CREATOR: {
            return { ...state, cc_creator: !state.cc_creator };
        }
        case TOGGLE_COLUMN: {
            const columns = [...state.columns];
            const column = { ...columns[action.payload] };
            column.checked = !column.checked;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case TOGGLE_CREATE: {
            const quota = action.payload;
            // if (state.create_max) {
            if (state.create_max) {
                return { ...state, create_max: false, create: quota === -1 || quota === -2, creating_user_client: quota === -2, is_customer: quota === -2 };
            } else {
                if (quota > 0) {
                    return { ...state, create: !state.create, creating_user_client: false };
                } else {
                    return { ...state, create_max: true, creating_user_client: false };
                }
            }
        }
        case TOGGLE_CUSTOM_PERMISSIONS: {
            return { ...state, has_custom_permissions: action.payload };
        }
        case TOGGLE_EMAIL_PREVIEW: {
            return { ...state, email_preview: !state.email_preview };
        }
        case TOGGLE_EXPORT: {
            return { ...state, export_list: action.payload };
        }
        case TOGGLE_EXPORT_FULL: {
            return { ...state, export_full: !state.export_full };
        }
        case TOGGLE_FILTERS: {
            return { ...state, filter_open: !state.filter_open };
        }
        case SET_FILTER_OPEN: {
            return {...state, filter_open: action.payload};
        }
        case TOGGLE_FIRST_BLOCK: {
            return { ...state, first_block_open: !state.first_block_open };
        }
        case TOGGLE_LIST_ALL: {
            return { ...state, list_selected: [], list_all: action.payload };
        }
        case TOGGLE_IS_CUSTOMER: {
            return { ...state, is_customer: !state.is_customer };
        }
        case TOGGLE_LICENCE_HISTORY: {
            return { ...state, licence_history: action.payload };
        }
        case TOGGLE_MOVE_ORGANISATION_CHANGE_TRIP: {
            return { ...state, move_organisation_change_trip: !state.move_organisation_change_trip };
        }
        case TOGGLE_PROFILE_DEPLOYED: {
            return { ...state, profile_deployed: action.payload };
        }
        case TOGGLE_REFRESH: {
            return { ...state, refresh: !state.refresh };
        }
        case TOGGLE_ROLE_DEPLOYED: {
            return { ...state, role_deployed: action.payload };
        }
        case TOGGLE_SELLER_AGENT: {
            return { ...state, is_seller_user: !state.is_seller_user };
        }
        case TOGGLE_IS_COMMERCIAL: {
            return { ...state, is_commercial: !state.is_commercial };
        }
        case TOGGLE_NETWORK_DIRECTOR: {
            return { ...state, is_network_director: !state.is_network_director };
        }
        case TOGGLE_SUPPORT_ACCESS: {
            return { ...state, access_to_support: !state.access_to_support };
        }
        case TOGGLE_SUSPEND_TRANSFER: {
            return { ...state, suspend_transfer: !state.suspend_transfer };
        }
        case TOGGLE_UPDATE_PASSWORD: {
            return { ...state, update_password: action.payload };
        }
        case TOGGLE_UPLOAD_PICTURE: {
            return { ...state, upload_picture: !state.upload_picture, upload_picture_step: 1 };
        }
        case TOGGLE_USER_TRANSFER: {
            return { ...state, transfer: !state.transfer, user_transfer: state.transfer ? null : state.user_transfer, user_transfer_error: state.transfer ? false : state.user_transfer_error };
        }
        case TOGGLE_USER_TRANSFER_ERROR: {
            return { ...state, user_transfer_error: !state.user_transfer_error };
        }
        case UPDATE_BIOGRAPHY: {
            return { ...state, biography: action.payload };
        }
        case UPDATE_CELLPHONE_NUMBER: {
            return { ...state, cellphone_number_error: '', cellphone_number: action.payload };
        }
        case UPDATE_CITY: {
            return { ...state, city_error: '', city: action.payload };
        }
        case UPDATE_CLIENT: {
            return { ...state, client_error: '', client: action.payload };
        }
        case UPDATE_CLIENTS: {
            return { ...state, client_error: '', clients: action.payload };
        }
        case UPDATE_COUNTRY: {
            return { ...state, country_error: '', country: action.payload };
        }
        case UPDATE_COMPANY: {
            return { ...state, company_error:'', company: action.payload };
        }
        case UPDATE_EMAIL: {
            return { ...state, email_error: '', email: action.payload };
        }
        case UPDATE_FILTER_CMS: {
            return {...state, filter_cms: action.payload};
        }
        case UPDATE_FILTER_COMPANY: {
            return { ...state, filter_company: action.payload };
        }
        case UPDATE_FILTER_CREATOR: {
            return { ...state, filter_creator: action.payload };
        }
        case UPDATE_FILTER_DATE_JOINED_GTE: {
            return { ...state, filter_date_joined_gte: action.payload };
        }
        case UPDATE_FILTER_DATE_JOINED_LTE: {
            return { ...state, filter_date_joined_lte: action.payload };
        }
        case UPDATE_FILTER_EMAIL: {
            return { ...state, filter_email: action.payload };
        }
        case UPDATE_FILTER_EMAIL_CHECKED: {
            return { ...state, filter_email_checked: action.payload };
        }
        case UPDATE_FILTER_FIRST_NAME: {
            return { ...state, filter_first_name: action.payload };
        }
        case UPDATE_FILTER_LAST_AUTHOR: {
            return { ...state, filter_last_author: action.payload };
        }
        case UPDATE_FILTER_LAST_NAME: {
            return { ...state, filter_last_name: action.payload };
        }
        case UPDATE_FILTER_LICENCE_TYPE: {
            return { ...state, filter_licence_type: action.payload };
        }
        case UPDATE_FILTER_MODIFIED_DATE_GTE: {
            return { ...state, filter_modified_date_gte: action.payload };
        }
        case UPDATE_FILTER_MODIFIED_DATE_LTE: {
            return { ...state, filter_modified_date_lte: action.payload };
        }
        case UPDATE_FILTER_PERIOD: {
            const period = action.payload;
            return {
                ...state,
                filter_period: period,
                filter_period_type: 0,
                filter_date_joined_gte: period === 'MODIFICATION' ? null : state.filter_date_joined_gte,
                filter_date_joined_lte: period === 'MODIFICATION' ? null : state.filter_date_joined_lte,
                filter_modified_date_gte: period === 'CREATION' ? null : state.filter_modified_date_gte,
                filter_modified_date_lte: period === 'CREATION' ? null : state.filter_modified_date_lte,
            };
        }
        case UPDATE_FILTER_PERIOD_TYPE: {
            return { ...state, filter_period_type: action.payload };
        }
        case UPDATE_FILTER_SHOW_DEACTIVATED: {
            return { ...state, show_deactivated: action.payload };
        }
        case UPDATE_FILTER_USER_TYPE: {
            return { ...state, filter_user_type: action.payload };
        }
        case UPDATE_FIRST_NAME: {
            return { ...state, first_name_error: '', first_name: action.payload };
        }
        case UPDATE_GENERATE_PASSWORD: {
            return { ...state, generate_password: action.payload };
        }
        case UPDATE_IGA_PASSWORD: {
            return { ...state, iga_password: action.payload };
        }
        case UPDATE_IGA_USERNAME: {
            return { ...state, iga_username: action.payload };
        }
        case UPDATE_LANG: {
            return { ...state, lang_error: '', lang: action.payload };
        }
        case UPDATE_BRANCH_CODE: {
            return { ...state, branch_code: action.payload };
        }
        case UPDATE_ADDITIONAL_BRANCH_CODES: {
            return { ...state, additional_branch_codes: action.payload };
        }
        case UPDATE_LAST_NAME: {
            return { ...state, last_name_error: '', last_name: action.payload };
        }
        case UPDATE_LIST_ORGANISATIONS: {
            return { ...state, list_organisations: action.payload };
        }
        case UPDATE_MOVE_SECONDARY_ORGANISATIONS: {
            return { ...state, move_organisation_secondary_organisations: action.payload };
        }
        case UPDATE_CONFIRM_PASSWORD: {
            return { ...state, confirm_password: action.payload };
        }
        case UPDATE_PASSWORD: {
            return { ...state, password_error: '', password: action.payload };
        }
        case UPDATE_PHONE_NUMBER: {
            return { ...state, phone_number_error: '', phone_number: action.payload };
        }
        case UPDATE_PICTURE: {
            return { ...state, picture_errors: null, upload_picture: false, upload_picture_step: 1, picture_progress: 0, picture: action.payload };
        }
        case UPDATE_PICTURE_PROGRESS: {
            return { ...state, picture_progress: action.payload };
        }
        case UPDATE_PICTURE_STEP: {
            return { ...state, upload_picture_step: action.payload };
        }
        case UPDATE_ROLE: {
            return { ...state, groups_error: '', groups: action.payload };
        }
        case UPDATE_STATE: {
            return { ...state, state_error: '', state: action.payload };
        }
        case UPDATE_STREET: {
            return { ...state, street_error: '', street: action.payload };
        }
        case UPDATE_TRIGRAM: {
            return { ...state, trigram_error: '', trigram: action.payload };
        }
        case UPDATE_USERNAME: {
            return { ...state, username_error: '', username: action.payload };
        }
        case UPDATE_TITLE: {
            return {...state, title_error: '', title: action.payload};
        }
        case UPDATE_USER_SELECTED: {
            const user = action.payload;
            if (user === 'all' && state.list) {
                return { ...state, list_selected: state.list.length === state.list_selected.length ? [] : [...state.list] };
            } else if (typeof user !== 'string') {
                const list_selected = [...state.list_selected];
                let deleted = false;
                for (let i = 0; i < list_selected.length; i++) {
                    if (list_selected[i].id === user.id) {
                        list_selected.splice(i, 1);
                        deleted = true;
                        break;
                    }
                }
                if (!deleted) {
                    list_selected.push(user);
                }
                return { ...state, list_selected: list_selected };
            }
            return state;
        }
        case UPDATE_USER_TRANSFER: {
            return { ...state, user_transfer_error: false, user_transfer: action.payload };
        }
        case UPDATE_USER_TRIP_TRANSFER: {
            return { ...state, user_trip_transfer: action.payload };
        }
        case UPDATE_ZIP_CODE: {
            return { ...state, zip_code_error: '', zip_code: action.payload };
        }
        case UPDATE_ALLOWED_EVENTS: {
            return {...state, zip_code_error: '', allowed_event_sites: action.payload};
        }
        case UPDATE_ALLOWED_TEAMS: {
            return {...state, zip_code_error: '', user_teams: action.payload};
        }
        case SET_COLUMNS: {
            return { ...state, columns: action.payload };
        }
        case SET_USER_SUGGESTIONS : {
            return { ...state, user_suggestions: action.payload };
        }
        case SET_USER_SUGGESTION_SELECTED : {
            return { ...state, user_suggestion_selected: action.payload };
        }
        case SET_LICENCE_HISTORY_COLUMNS: {
            return { ...state, licence_history_configuration: { ...state.licence_history_configuration, columns: action.payload } };
        }
        case TOGGLE_LICENCE_HISTORY_COLUMN: {
            const lh_columns = [...state.licence_history_configuration.columns];
            const lh_col = { ...lh_columns[action.payload] };
            lh_col.checked = !lh_col.checked;
            lh_columns[action.payload] = lh_col;
            return { ...state, licence_history_configuration: { ...state.licence_history_configuration, columns: lh_columns } };
        }
        case ADD_LICENCE_HISTORY_PREFERENCE: {
            const updated_prefs = [...state.licence_history_configuration.preferences, ...action.payload];
            return { ...state, licence_history_configuration: { ...state.licence_history_configuration, preferences: updated_prefs }, licence_history_first_preference_loaded: true };
        }
        case SET_LICENCE_HISTORY_PREFERENCE: {
            return { ...state, licence_history_configuration: { ...state.licence_history_configuration, preferences: action.payload } };
        }
        case UPDATE_LICENCE_HISTORY_CRITERIA: {
            return { ...state, licence_history_criteria: { ...state.licence_history_criteria, ...action.payload } };
        }
        case UPDATE_LICENCE_HISTORY_LOADING: {
            return { ...state, licence_history_loading: action.payload };
        }
        case TOGGLE_LICENCE_HISTORY_REFRESH: {
            return { ...state, licence_history_refresh: !state.licence_history_refresh };
        }
        case UPDATE_CMS: {
            return {...state, cms_error: '', cms: action.payload};
        }
        default:
            return state;
    }
};